<script>
    import { eventGroupState } from "@app/store/eventGroupStore.svelte.js";
    import { projectState } from "@app/store/projectStore.svelte.js";
    import * as m from '@app/paraglide/messages.js';
    import flexbox from "@cclib/dict/flexbox.js";
    import { highlightExcessCharacters } from "@app/lib/highlightExcessCharacters.js";
    
    /** @type {{event?: any, eventIndex: any, height?: number, rounded?: boolean}} */
    let { event, eventIndex, height = 160, rounded = true } = $props();
    
    let currentEvent = $derived(event || eventGroupState[projectState.selected]?.events[eventIndex]);
    let eventText = $derived.by(() => {
        if (!currentEvent || !eventGroupState[projectState.selected]) {
            return "";
        }

        return highlightExcessCharacters(
            currentEvent.text,
            eventGroupState[projectState.selected].maxChars,
        );
    });
    </script>
    
    <div
        role="region"
        aria-label={m.event_preview_aria_label()}
        class="text-white bg-secondary bg-opacity-50 p-2 EditorPreviewText {rounded ? 'rounded' : ''} text-{flexbox
            .alignmentMap[currentEvent?.alignment]}"
        style="height:{height}px; font-family: '{eventGroupState[projectState.selected]?.fontFamily || 'plexMono'}' !important; font-size: {eventGroupState[projectState.selected]?.fontSize || 18}px; line-height: 100%; direction: {eventGroupState[
            projectState?.selected
        ]?.rtl
            ? 'rtl'
            : 'ltr'};">
        {@html eventText}
    </div>
    
    <style lang="css">
    .EditorPreviewText {
        overflow-y: auto;
        overflow-x: hidden;
    }
    </style>
